import * as React from 'react'
import {connect} from 'react-redux'
import HomePageV1 from './HomePage_v1.js'
import HomepageV2 from './HomePage_v2'
import {getPlatformTokenInfo} from "../../tools/utils";

class HomePageIndex extends React.Component{
  constructor(props){
    super(props);
    this.state={
      fromNewEnter:true
    }
  }
  componentWillMount(){
    let fromNewEnter = !!getPlatformTokenInfo() && getPlatformTokenInfo().loginWay==='newLogin';
    this.setState({fromNewEnter})
  }
  componentDidMount(){}

  render() {
    return (
      <div>
        {
          this.state.fromNewEnter?
          // false?
            <HomepageV2 {...this.props}/>:
            <HomePageV1/>
        }
      </div>
    )
  }
}

function mapState(state) {
  return {
    token: state.token
  }
}
export default connect(mapState)(HomePageIndex)
